"use client";

import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY_PREFIX = "lia_notification_opened";

function storageKey(
  userId?: string | number | null,
  screenKey?: string,
): string {
  const base =
    userId != null ? `${STORAGE_KEY_PREFIX}_${userId}` : STORAGE_KEY_PREFIX;
  return screenKey ? `${base}_${screenKey}` : base;
}

export function useLiaNotificationCache(
  userId?: string | number | null,
  screenKey?: string,
): [boolean, () => void] {
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    try {
      const key = storageKey(userId, screenKey);
      const raw = localStorage.getItem(key);
      setHasOpened(raw === "1");
    } catch {
      setHasOpened(false);
    }
  }, [userId, screenKey]);

  const markOpened = useCallback(() => {
    try {
      const key = storageKey(userId, screenKey);
      localStorage.setItem(key, "1");
      setHasOpened(true);
    } catch {
      // ignore
    }
  }, [userId, screenKey]);

  return [hasOpened, markOpened];
}
